module.exports = __webpack_public_path__ + "assets/images/key/key_hk_2019.svg?v=99020981";